'use server'

import { apiRequest, ApiResponse } from '../request'

export interface SystemEvent {
    id: string
    createdAt: string
    userId?: number
    user?: { id: number; name: string; email: string }
    module: string
    resource?: string
    action: string
    description: string
    entityType?: string
    entityId?: string
    metadata?: any
    error?: string
    ipAddress?: string
    userAgent?: string
    url?: string
    method?: string
    companyId?: number
    company?: { id: number; name: string }
}

export interface EventsListResponse {
    items: SystemEvent[]
    total: number
    page: number
    limit: number
    totalPages: number
}

export interface EventsFilters {
    page?: number
    limit?: number
    module?: string
    resource?: string
    action?: string
    userId?: number
    search?: string
}

export interface EventModulesResponse {
    modules: { module: string; _count: number }[]
    resources: { module: string; resource: string | null; _count: number }[]
}

export async function getEvents(filters: EventsFilters = {}): Promise<ApiResponse<EventsListResponse>> {
    return apiRequest<EventsListResponse>('events', { params: filters })
}

export async function getEvent(id: string): Promise<ApiResponse<SystemEvent>> {
    return apiRequest<SystemEvent>(`events/${id}`, {})
}

export async function getEventModules(): Promise<ApiResponse<EventModulesResponse>> {
    return apiRequest<EventModulesResponse>('events/modules', {})
}

export interface LoginHistoryItem {
    id: string
    createdAt: string
    ipAddress?: string | null
    userAgent?: string | null
}

// Ultimos logins do proprio usuario (self, sem permissao de security:events).
export async function getMyLoginHistory(): Promise<
    ApiResponse<{ items: LoginHistoryItem[] }>
> {
    return apiRequest<{ items: LoginHistoryItem[] }>('events/me/logins', {})
}

export const MODULE_LABELS: Record<string, string> = {
    auth: 'Autenticação',
    person: 'Cadastros',
    administrative: 'Administrativo',
    atendimento: 'Atendimento',
    financial: 'Financeiro',
    sales: 'Vendas',
    medical: 'Médico',
    hospital: 'Hospital',
    commerce: 'Comércio',
    stock: 'Estoque',
    fiscal: 'Fiscal',
    marketing: 'Marketing',
    core: 'Sistema',
    automation: 'Automação',
    notification: 'Notificação',
}

export const MODULE_COLORS: Record<string, string> = {
    auth: 'badge-warning',
    person: 'badge-secondary',
    administrative: 'badge-secondary',
    atendimento: 'badge-info',
    financial: 'badge-success',
    sales: 'badge-accent',
    medical: 'badge-secondary',
    hospital: 'badge-error',
    commerce: 'badge-info',
    stock: 'badge-warning',
    fiscal: 'badge-secondary',
    marketing: 'badge-accent',
    core: 'badge-ghost',
    automation: 'badge-info',
    notification: 'badge-ghost',
}
